import { TCAppConfig } from '../../../../../shared/app-configs/tc-app-configs';

/**
 * Fetch product component details using the given API caller.
 *
 * @param executeGet - The API call function from your custom hook.
 * @param tcId - The TE_ID.
 * @param shipmentId - The shipment identifier.
 * @param productId - The product identifier.
 * @param inputTcId - The input TC identifier.
 * @returns A promise that resolves with the product component details.
 * @throws An error if the fetch fails.
 */
export async function fetchProductComponentDetails(
  executeGet: (url: string, params: Record<string, any>) => Promise<any>,
  tcId: string,
  shipmentId: string,
  productId: string,
  inputTcId: string
): Promise<any> {
  if (!inputTcId) return null;

  try {
    const response = await executeGet(TCAppConfig.GET_INPUT_TC_PRODUCTDETAILS_INFO_NEW, {
      tcId,
      shipmentId,
      productId,
      inputTcId,
    });
    return response;
  } catch (err) {
    console.error('Error fetching product component details:', err);
    throw new Error('Failed to load product component details.');
  }
}


/**
 * Retrieves shipment data by matching the product number.
 *
 * @param data - Array of ProductShipmentResponse objects.
 * @param tcProductNo - The product number to look up.
 * @returns An object with productId and shipmentId if found, otherwise undefined.
 */

export const getProductShipmentDataByProductNo = (
    data: any[],
    tcProductNo: string
  ): { productId: string; shipmentId: string[] } | undefined => {
    // Find the shipment where the tcProductNo matches the provided tcProductNo.
    const shipment = data?.filter(
      (shipment) => shipment.tcProductNo === tcProductNo
    );
  
    // Return the shipment's productId and shipmentId if found, else return undefined.
    return shipment
      ? { productId: shipment[0]?.productId, shipmentId: shipment.map(({shipmentId})=>shipmentId) }
      : undefined;
  };
  
  